import { Navbar } from 'react-bootstrap';
import { useTenant } from '../../context/TenantContext';
import appHeaderLogo from '../../assets/images/app-header-logo.svg';

const Header = () => {
  const { loading } = useTenant();

  // Use tenant logo if available, otherwise use default logo
  const logoUrl = appHeaderLogo;

  return (
    <Navbar expand="xl" sticky="top" className="custom-header">
      <img
        src={logoUrl}
        alt="Logo"
        className="mx-5"
        style={{ opacity: loading ? 0.5 : 1 }}
      />
    </Navbar>
  );
};

export default Header;
